import { axiosInstance } from "api/axios-config/axios-config";
import { UpdatePermissions } from "api/models/request/user-role/permissions";
import {
  AddRole,
  GetRoles,
  UpdateRole,
} from "api/models/request/user-role/roles";
import { Pagination } from "api/models/response/pagination";
import { IPermissionCollectionProperties } from "mobx-stores/_models/user-roles/permission";
import { IRoleProperties } from "mobx-stores/_models/user-roles/role";

class RolePermissionsBusiness {
  readonly roleUrl = "/api/app/role";
  readonly permissionUrl = "/api/permission-management/permissions";

  public getRoleList = async () => {
    try {
      var res = await axiosInstance.get<Pagination<IRoleProperties>>(
        `${this.roleUrl}/list`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getRoles", error);
      return Promise.reject(error);
    }
  };

  public getRoles = async (request: GetRoles) => {
    try {
      var res = await axiosInstance.get<Pagination<IRoleProperties>>(
        this.roleUrl,
        {
          params: request,
        }
      );
      return res.data;
    } catch (error) {
      console.error("Fail getUsers", error);
      return Promise.reject(error);
    }
  };

  public addRole = async (addRole: AddRole) => {
    try {
      var res = await axiosInstance.post<IRoleProperties>(
        this.roleUrl,
        addRole
      );
      return res.data;
    } catch (error) {
      console.error("Fail addRole", error);
      return Promise.reject(error);
    }
  };

  public getRoleById = async (id: string) => {
    try {
      var res = await axiosInstance.get<IRoleProperties>(
        `${this.roleUrl}/${id}`
      );
      return res.data;
    } catch (error) {
      console.error("Fail getRoleById", error);
      return Promise.reject(error);
    }
  };

  public updateRole = async (id: string, update: UpdateRole) => {
    try {
      var res = await axiosInstance.put<IRoleProperties>(
        `${this.roleUrl}/${id}`,
        update
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateRole", error);
      return Promise.reject(error);
    }
  };

  public deleteRole = async (roleId: string) => {
    try {
      var res = await axiosInstance.delete(`${this.roleUrl}/${roleId}`);
      return res.data;
    } catch (error) {
      console.error("Fail deleteRole", error);
      return Promise.reject(error);
    }
  };

  public getPermissionsByRoleName = async (roleName: string) => {
    try {
      const param = {
        providerName: "R",
        providerKey: roleName,
      };
      var res = await axiosInstance.get<IPermissionCollectionProperties>(
        `${this.permissionUrl}`,
        {
          params: param,
        }
      );
      return res.data;
    } catch (error) {
      console.error("Fail getPermissionsByRoleId", error);
      return Promise.reject(error);
    }
  };

  public updateRolePermissions = async (
    roleName: string,
    update: UpdatePermissions
  ) => {
    try {
      const param = {
        providerName: "R",
        providerKey: roleName,
      };
      var res = await axiosInstance.put(`${this.permissionUrl}`, update, {
        params: param,
      });
      return res.data;
    } catch (error) {
      console.error("Fail updateRolePermissions", error);
      return Promise.reject(error);
    }
  };
}

export const rolePermissionsBusiness = new RolePermissionsBusiness();
